import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { Button } from "@components/buttons";
import { DepositContext } from "@state/context/payment/DepositContext";

export default observer(function DepositMultiStepFooter() {
	const {
		resetMultiStepFlags,
		isRedirectingToPaymentPage,
		isLoadingProcess,
	} = useContext(DepositContext);

	const { t } = useTranslation("payment");

	return (
		<>
			<Button
				className="card--primary__footer__btn btn btn--base btn--accent btn--icon"
				type="submit"
				disabled={isLoadingProcess || isRedirectingToPaymentPage}
				btnText={t<string>("COMMON.NEXT_BUTTON")}
				iconClassName="u-icon u-icon--tny u-icon--arrow-right u-color--accent--text"
			></Button>

			<button
				className="card--primary__footer__btn btn btn--base btn--primary--inverted"
				onClick={() => {
					resetMultiStepFlags();
					window.scrollTo(0, 0);
				}}
			>
				<span className="btn__label">{t<string>("COMMON.BACK")}</span>
			</button>
		</>
	);
});
